import { Link } from 'react-router-dom';
import type { SearchResult } from '../api/types';
import { searchResultHref } from '../lib/links';
import { Icon } from './ui/Icon';
import { KIND_ICON, KIND_LABEL } from './GlobalSearch';

export function SearchResults({ results, query }: { results: readonly SearchResult[]; query: string }) {
  if (results.length === 0) {
    return (
      <div className="gsl-panel flex flex-col items-center gap-2 px-6 py-12 text-center">
        <Icon name="search" size={28} className="text-muted-foreground" />
        <p className="text-sm font-medium">Nothing matched “{query}”</p>
        <p className="max-w-md text-sm text-muted-foreground">
          Search covers customer and supplier names and numbers, job references and document titles. File contents are
          never indexed.
        </p>
      </div>
    );
  }
  return (
    <ul className="gsl-panel divide-y divide-border" aria-label="Search results">
      {results.map((r) => (
        <li key={`${r.kind}-${r.id}`}>
          <Link to={searchResultHref(r)} className="flex items-center gap-3 px-4 py-3 no-underline hover:bg-surface-raised">
            <span className="gsl-tile-icon">
              <Icon name={KIND_ICON[r.kind]} size={18} />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block truncate text-sm font-medium">{r.title}</span>
              <span className="block truncate text-xs text-muted-foreground">
                {KIND_LABEL[r.kind]}
                {r.kind !== 'document' && r.number ? <span className="gsl-num"> {r.number}</span> : null}
                {r.branchCode ? ` · ${r.branchCode}` : ''}
                {r.subtitle ? ` · ${r.subtitle}` : ''}
              </span>
            </span>
            {r.status ? <span className="shrink-0 text-xs text-muted-foreground">{r.status}</span> : null}
            <Icon name="chevron-right" size={16} className="shrink-0 text-muted-foreground" />
          </Link>
        </li>
      ))}
    </ul>
  );
}
